import { Icon } from '@iconify/react'
import { Alert, Button, CircularProgress, IconButton } from '@mui/material'
import { t } from 'i18next'


type PostProcessProps = {
    onRefresh: () => void,
    isActive?: boolean,
    isReloading: boolean,
}


function PostProcess({ onRefresh, isActive, isReloading }: PostProcessProps) {


    if (!isActive) return <></>

    return (
        <Alert
            sx={{ my: 2 }}
            severity='warning'
            action={
                isReloading ? <CircularProgress size={18} sx={{ alignSelf: 'center', justifySelf: 'center', mr: 0.5 }} /> : <IconButton sx={{ alignSelf: 'center', justifySelf: 'center' }} onClick={onRefresh} size='small'><Icon icon={'clarity:refresh-line'} color='white'></Icon></IconButton>}
        >
            {t('postProcessingInfoBanner:trainingDataIsNotUpToDate')}
        </Alert>
    )
}

export default PostProcess